import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface dashboardState {
  chart_list_data: string | number | Array;
  componentData : any; // Adjusted to allow any type for componentData
}
const initialState: dashboardState = {
  chart_list_data: 1,
  componentData:{}
};

const dashboardSlice = createSlice({
  name: "chartListDetails",
  initialState,
  reducers: {
    setChartListData: (state, action: PayloadAction<string | number>) => {
      state.chart_list_data = action.payload;
    },

    setComponetData: (state, action) => {
      const { key, component } = action.payload;
      state.componentData[key] = {
        ...(state.componentData[key] || {}),
        ...component,
      };
    }

  },
});

export const { setChartListData, setComponetData } = dashboardSlice.actions;
export default dashboardSlice.reducer;
